<template>
  <div class="flex justify-between gap-2">
    <button
      v-for="item in shareButtonsData"
      :key="item.type"
      type="button"
      class="flex flex-1 flex-col items-center gap-1"
      @click="handleShareButtonAction(item.type, item.link)"
    >
      <span
        class="flex h-11 w-11 items-center justify-center rounded-full border transition-colors"
        :class="
          pressedType === item.type
            ? 'bg-success-light border-success text-success'
            : 'bg-white border-gray-200 text-stone-700'
        "
      >
        <component :is="item.icon" class="w-5 h-5" />
      </span>
      <span class="text-xs text-stone-700">{{ item.label }}</span>
    </button>
  </div>
</template>

<script setup lang="ts">
import IconFacebook from '~/components/icons/IconFacebook'
import { Copy, Mail, MessageCircle } from 'lucide-vue-next'

const { pageTitle, link } = defineProps<{
  pageTitle: string
  link: string
}>()

const { t } = useI18n()

const shareButtonsData = computed(() => [
  {
    type: 'copy_link',
    label: t('dateRequest.generalSuccessShareOptions.link'),
    icon: Copy,
  },
  {
    type: 'email',
    label: t('dateRequest.generalSuccessShareOptions.email'),
    link: `mailto:?subject=${t(
      'product.gallery.shareModal.shareEventSubject'
    )}: ${pageTitle}&body=${t(
      'product.gallery.shareModal.shareEventMessage'
    )}: ${link}`,
    icon: Mail,
  },
  {
    type: 'whatsapp',
    label: t('dateRequest.generalSuccessShareOptions.whatsapp'),
    link: `whatsapp://send?text=${t(
      'product.gallery.shareModal.shareEventMessage'
    )}: ${link}`,
    icon: MessageCircle,
  },
  {
    type: 'facebook',
    label: t('dateRequest.generalSuccessShareOptions.facebook'),
    link: `https://www.facebook.com/sharer.php?u=${link}`,
    icon: IconFacebook,
  },
])

const pressedType = ref<string | null>(null)
let pressedTimeout: ReturnType<typeof setTimeout> | undefined

const markPressed = (type: string) => {
  pressedType.value = type
  clearTimeout(pressedTimeout)
  pressedTimeout = setTimeout(() => {
    pressedType.value = null
  }, 2000)
}

const handleClickCopyLinkToClipboard = () => {
  const textArea = document.createElement('textarea')
  textArea.value = link
  document.body.appendChild(textArea)
  textArea.focus({ preventScroll: true })
  textArea.select()

  try {
    document.execCommand('copy')
  } catch (err) {
    console.error('Unable to copy to clipboard', err)
  }

  textArea.remove()
}

const handleShareButtonAction = (type: string, actionLink?: string) => {
  markPressed(type)

  if (type === 'copy_link') {
    handleClickCopyLinkToClipboard()
  } else {
    window.open(actionLink, '_blank')
  }
}
</script>
